var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project"},[(_vm.project)?_c('ProjectDetails',{attrs:{"project":_vm.project}}):_vm._e(),(!_vm.project)?_c('h1',[_vm._v("Could not find this project.")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }